export default "__VITE_ASSET__e7cc83d5__"